<template>
  <div class="smart-breadcrumb w-full bg-white smart-card--small">
    <div class="container-breadcrumb w-full h-full flex align-center">
      <v-breadcrumbs v-if="items" :items="items" divider=">">
        <template v-slot:item="props">
          <component
            :is="breadcrumbTag(props.item)"
            :class="breadcrumbClass(props.item)"
            class="f-z-breadcrumbs"
            @click="changeRoute(props.item)"
          >
            {{ props.item.text }}
          </component>
        </template>
      </v-breadcrumbs>
    </div>
  </div>
</template>

<script>
import wait from '@/globalFunctions/wait';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission',
      items: 'breadcrumbs/items'
    })
  },
  methods: {
    changeRoute(item) {
      if (item.onClick) {
        item.onClick(this.$root, item.name);
        return;
      }
      this.$router.push({ name: item.name });
    },
    breadcrumbTag(item) {
      const lastItem = this.items[this.items.length - 1];
      return item.name === (lastItem.name && item.name === this.$route.name) ||
        (lastItem.name === item.name && (typeof lastItem.last === 'undefined' || lastItem.last))
        ? 'p'
        : 'button';
    },
    breadcrumbClass(item) {
      const isCurrentRoute = this.breadcrumbTag(item) === 'p';
      return isCurrentRoute ? 'text-brand-primary' : 'font-opacity-md';
    },
  },
  async updated() {
    const breadcrumb = document.getElementsByClassName('container-breadcrumb')[0];
    await wait(1000);
    breadcrumb.scrollTo(9999, 0);
  }
}
</script>

<style lang="scss">
.container-breadcrumb {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
}
.v-breadcrumbs.theme--light {
  padding: 0;
}
.f-z-breadcrumbs {
  font-size: $font-size-paragraph;
}

.smart-breadcrumb {
  box-shadow: 0 1px 4px rgba($color-ui-black, $opacity-low-min);
}

@media (max-width: 600px) {
  .smart-breadcrumb {
    .container-breadcrumb {
      scroll-behavior: smooth;
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      flex-wrap: nowrap;
      box-shadow: 0 0 10px 10px rgba(0,0,0,.05);

      &:before {
        content: '';
        display: block;
        width: 1px;
        height: 5px;
        position: absolute;
        top: 20px;
        left: 0;
        z-index: 1;
        background: white;
        box-shadow: 0px 0px 10px 15px white;
      }

      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        * {
          display: flex;
          white-space: nowrap;
        }
      }
    }
  }
}

</style>
